import { type ChargeBeePlanId } from '@prerender/billing-shared';

// The Security and Access page and the integration wizard header both offer the
// same token to copy, and one funnel counts both. A payload that differs by call
// site reads there as a drop-off, so the two build it from here rather than each
// restating it.
export const TOKEN_COPIED_EVENT = 'Token Copied';

export const tokenCopiedPayload = (subscriptionPlan: ChargeBeePlanId) => ({
  location: window.location.pathname,
  subscription_plan: subscriptionPlan,
});
